import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { dateFormatWithoutHours } from '@shared/constants/otherConstants';
import { useDeadlineWarning } from '../hooks/useDeadLineWarning';

interface TestingEndDateCellProps {
    date: string | null | undefined;
}

const TestingEndDateCell = ({ date }: TestingEndDateCellProps) => {
    const { t } = useTranslation();
    const warning = useDeadlineWarning(date);
    const today = dayjs().startOf('day');
    const end = date ? dayjs(date).startOf('day') : null;
    const isOverdue = end && end.isBefore(today);
    const isWarning = warning && !isOverdue;
    const color = isOverdue ? 'error.main' : isWarning ? 'warning.main' : 'inherit';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color }}>
            {date ? dayjs(date).format(dateFormatWithoutHours) : t('no_info')}
            {warning && (
                <Tooltip title={warning}>
                    <InfoOutlinedIcon fontSize="small" sx={{ cursor: 'default', flexShrink: 0 }} />
                </Tooltip>
            )}
        </Box>
    );
};

export default TestingEndDateCell;
